/* see docs/EXTRACTED_COMMENTS.md#c068 */

let normalizeCtx: CanvasRenderingContext2D | null = null

function getCtx(): CanvasRenderingContext2D | null {
  if (!normalizeCtx) {
    normalizeCtx = document.createElement("canvas").getContext("2d")
  }
  return normalizeCtx
}

/** `#rgb` / `#rrggbb` → `rgb(r, g, b)`. */
export function hexToRgb(hex: string): string {
  let h = hex.replace(/^#/, "")
  if (h.length === 3) {
    h = h
      .split("")
      .map(c => c + c)
      .join("")
  }
  const n = Number.parseInt(h, 16)
  const r = (n >> 16) & 255
  const g = (n >> 8) & 255
  const b = n & 255
  return `rgb(${r}, ${g}, ${b})`
}

/* see docs/EXTRACTED_COMMENTS.md#c377 */
export function toRgb(input: string | null | undefined): string | null {
  if (!input) return null
  const trimmed = input.trim()
  if (!trimmed) return null

  const ctx = getCtx()
  if (!ctx) return trimmed

  // see docs/EXTRACTED_COMMENTS.md#c378
  ctx.fillStyle = "#000000"
  ctx.fillStyle = trimmed
  const normalized = ctx.fillStyle
  if (typeof normalized !== "string") return trimmed

  return normalized.startsWith("#") ? hexToRgb(normalized) : normalized
}

/* see docs/EXTRACTED_COMMENTS.md#c379 */
export function toHex(input: string | null | undefined): string {
  if (!input) return "#000000"
  const ctx = getCtx()
  if (!ctx) return "#000000"

  ctx.fillStyle = "#000000"
  ctx.fillStyle = input.trim()
  const normalized = ctx.fillStyle
  if (typeof normalized === "string" && normalized.startsWith("#")) {
    return normalized
  }

  // rgba(...) — strip alpha and rebuild a hex.
  const match = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(normalized)
  if (!match) return "#000000"
  const toPart = (value: string) =>
    Number(value).toString(16).padStart(2, "0")
  return `#${toPart(match[1])}${toPart(match[2])}${toPart(match[3])}`
}
